export enum CacheTag {
  USER_QUIZ_DATA_TAG = 'user-quiz-data',
}
